import classNames from "classnames";
import React from "react";
import styles from "./AscPopoverOption.module.scss";

interface AscPopoverOptionsContainerProps {
  children?: React.ReactNode;
  header?: React.ReactNode;
  afterSelect?: () => void;
  className?: string;
  optionItemClassName?: string;
}

export function AscPopoverOptionsContainer({
  children,
  header,
  afterSelect,
  className,
}: AscPopoverOptionsContainerProps) {
  return (
    <div className={classNames(styles.selectOptionsContainer, className)}>
      {header}
      {children}
    </div>
  );
}
